import React from 'react';
import AdminDashboard from '../components/AdminDashboard';

const AdminPage = () => {
  return <AdminDashboard />;
};

export default AdminPage;